"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const ObjectivesClient_1 = require("client/ObjectivesClient");
const RefetchQueryContext_1 = require("context/RefetchQueryContext");
const ToastContext_1 = require("context/ToastContext");
const useJira_1 = __importDefault(require("hooks/useJira"));
const useUrl_1 = require("hooks/useUrl");
const caseConverter_1 = require("utils/caseConverter");
const Modal_1 = __importStar(require("components/design-system/Modal"));
const HelperUtils_1 = require("src/utils/HelperUtils");
const FooterModalJira = ({ closeCurrentModal, primaryTitleButton, isViewChildOnCreate, modalType, currentIntegration, setObjectiveValue, changeValue, objectiveId }) => {
    const { closeModal } = (0, Modal_1.useModal)() || {};
    const { refetchObjective } = (0, RefetchQueryContext_1.useRefetchQuery)();
    const { addToast } = (0, ToastContext_1.useToastContext)();
    const { url } = (0, useUrl_1.useUrl)();
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const { objectiveId: parentObjectiveId } = (0, react_router_dom_1.useParams)();
    const stepModal = (0, useJira_1.default)((state) => state.stepModal);
    const setStepModal = (0, useJira_1.default)((state) => state.setStepModal);
    const jiraData = (0, useJira_1.default)((state) => state.jiraData);
    const selectedJIRA = (0, useJira_1.default)((state) => state.selectedJIRA);
    const isImportChild = (0, useJira_1.default)((state) => state.isImportChild);
    const syncOption = (0, useJira_1.default)((state) => state.syncOption);
    const setSyncOption = (0, useJira_1.default)((state) => state.setSyncOption);
    const removeChildrenLink = (0, useJira_1.default)((state) => state.removeChildrenLink);
    const setRemoveChildrenLink = (0, useJira_1.default)((state) => state.setRemoveChildrenLink);
    const currentIntegrationId = (0, react_1.useMemo)(() => currentIntegration === null || currentIntegration === void 0 ? void 0 : currentIntegration.id, [currentIntegration]);
    const exitModal = () => {
        setSyncOption('all');
        setRemoveChildrenLink(false);
        closeCurrentModal();
        closeModal && closeModal();
    };
    const isButtonModalDisabled = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        return modalType == 'import-child'
            ? (jiraData === null || jiraData === void 0 ? void 0 : jiraData.length) == 0
            : stepModal == 'choose-data' &&
                (!((_a = selectedJIRA === null || selectedJIRA === void 0 ? void 0 : selectedJIRA.data) === null || _a === void 0 ? void 0 : _a.id) ||
                    ((_b = currentIntegration === null || currentIntegration === void 0 ? void 0 : currentIntegration.data) === null || _b === void 0 ? void 0 : _b.id) == ((_c = selectedJIRA === null || selectedJIRA === void 0 ? void 0 : selectedJIRA.data) === null || _c === void 0 ? void 0 : _c.id));
    }, [modalType, jiraData, stepModal, selectedJIRA, currentIntegration]);
    const getConvertedJira = () => {
        const convertedJIRA = (0, caseConverter_1.toSnakeCase)((0, cloneDeep_1.default)(selectedJIRA));
        convertedJIRA.data = selectedJIRA.data;
        convertedJIRA.import_child_issues = isImportChild;
        convertedJIRA.sync_option = syncOption;
        if (modalType === 'edit') {
            convertedJIRA.enforce_correct_alignment = removeChildrenLink;
        }
        return convertedJIRA;
    };
    const showSuccessToast = (error, convertedJIRA) => {
        var _a, _b;
        addToast({
            title: (0, HelperUtils_1.getObjectiveLocale)((error === null || error === void 0 ? void 0 : error.code) == 207
                ? 'Linking is successful but some fields have failed to sync'
                : 'Linking is successful'),
            msg: (error === null || error === void 0 ? void 0 : error.code) == 207
                ? `[${(_a = convertedJIRA === null || convertedJIRA === void 0 ? void 0 : convertedJIRA.data) === null || _a === void 0 ? void 0 : _a.key}] ${(0, HelperUtils_1.getObjectiveLocale)((_b = error === null || error === void 0 ? void 0 : error.message) === null || _b === void 0 ? void 0 : _b.replace(/["[\]']+/g, ''))}`
                : '',
            type: (error === null || error === void 0 ? void 0 : error.code) == 207 ? 'warning' : 'success'
        });
    };
    const showChildToast = () => {
        addToast({
            title: (0, HelperUtils_1.getObjectiveLocale)('Import child issues is started'),
            msg: (0, HelperUtils_1.getObjectiveLocale)('We are currently importing your Jira issues. Please wait a few minutes.'),
            type: 'info'
        });
    };
    const showFailedToast = (error, convertedJIRA) => {
        var _a, _b;
        addToast({
            title: (0, HelperUtils_1.getObjectiveLocale)('Linking failed'),
            msg: `[${(_a = convertedJIRA === null || convertedJIRA === void 0 ? void 0 : convertedJIRA.data) === null || _a === void 0 ? void 0 : _a.key}] ${(0, HelperUtils_1.getObjectiveLocale)((_b = error === null || error === void 0 ? void 0 : error.message) === null || _b === void 0 ? void 0 : _b.replace(/["[\]']+/g, ''))}`,
            type: 'error'
        });
    };
    const createJira = () => __awaiter(void 0, void 0, void 0, function* () {
        const convertedJIRA = getConvertedJira();
        const { isSuccess, error } = yield (0, ObjectivesClient_1.postJIRALink)(objectiveId, convertedJIRA);
        if (isSuccess) {
            showSuccessToast(error, convertedJIRA);
            isImportChild && showChildToast();
            refetchObjective(objectiveId);
            return;
        }
        showFailedToast(error, convertedJIRA);
    });
    const _getPreviewJira = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const convertedJIRA = getConvertedJira();
        const { isSuccess, data } = yield (0, ObjectivesClient_1.getPreviewJira)(convertedJIRA);
        if (isSuccess) {
            //sidebar data
            setObjectiveValue &&
                setObjectiveValue((draft) => {
                    var _a;
                    return (0, caseConverter_1.toCamelCase)(Object.assign(Object.assign({}, data), { permissions: draft.permissions, id: draft.id, weight: draft.weight, measurement: Object.assign(Object.assign({}, data === null || data === void 0 ? void 0 : data.measurement), { unitId: (_a = data === null || data === void 0 ? void 0 : data.measurement) === null || _a === void 0 ? void 0 : _a.id }), parentIds: (pathname === null || pathname === void 0 ? void 0 : pathname.includes('addgoal'))
                            ? [parseInt(parentObjectiveId)]
                            : draft.parentIds }));
                });
            // card data
            const changedData = (0, caseConverter_1.toCamelCase)(data);
            changedData.measurement = Object.assign(Object.assign({}, changedData === null || changedData === void 0 ? void 0 : changedData.measurement), { unitId: (_a = changedData === null || changedData === void 0 ? void 0 : changedData.measurement) === null || _a === void 0 ? void 0 : _a.id });
            changedData === null || changedData === void 0 ? true : delete changedData.permissions;
            changedData === null || changedData === void 0 ? true : delete changedData.id;
            changedData === null || changedData === void 0 ? true : delete changedData.weight;
            changeValue === null || changeValue === void 0 ? void 0 : changeValue(objectiveId, changedData);
            refetchObjective(objectiveId);
            return;
        }
        addToast({
            msg: (0, HelperUtils_1.getObjectiveLocale)('Get preview issue failed'),
            type: 'error'
        });
        refetchObjective(objectiveId);
    });
    const importChild = () => __awaiter(void 0, void 0, void 0, function* () {
        const { isSuccess } = yield (0, ObjectivesClient_1.importChildIssueJIRA)(objectiveId, currentIntegrationId);
        if (isSuccess) {
            refetchObjective(objectiveId);
            showChildToast();
        }
    });
    const editJira = () => __awaiter(void 0, void 0, void 0, function* () {
        const convertedJIRA = getConvertedJira();
        const { isSuccess, error } = yield (0, ObjectivesClient_1.editJIRALink)(objectiveId, currentIntegrationId, convertedJIRA);
        if (isSuccess) {
            showSuccessToast(error, convertedJIRA);
            isImportChild && showChildToast();
            refetchObjective(objectiveId);
            return;
        }
        showFailedToast(error, convertedJIRA);
    });
    const functionButtonModal = (0, react_1.useMemo)(() => modalType == 'import-child'
        ? importChild
        : (url === null || url === void 0 ? void 0 : url.includes('create-objective')) || (pathname === null || pathname === void 0 ? void 0 : pathname.includes('addgoal'))
            ? _getPreviewJira
            : currentIntegrationId
                ? editJira
                : createJira, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        modalType,
        url,
        pathname,
        currentIntegrationId,
        selectedJIRA,
        isImportChild,
        syncOption,
        removeChildrenLink
    ]);
    const submitJira = () => __awaiter(void 0, void 0, void 0, function* () {
        yield functionButtonModal();
        exitModal();
    });
    return stepModal != 'child-issues' || modalType == 'import-child' ? (react_1.default.createElement(Modal_1.default.Footer, { useBorder: false, primaryButton: {
            text: primaryTitleButton,
            onClick: () => stepModal == 'choose-data' ? setStepModal('confirm') : submitJira(),
            disabled: isButtonModalDisabled
        }, secondaryButton: {
            text: 'Cancel',
            onClick: () => isViewChildOnCreate ? setStepModal('confirm') : exitModal()
        } })) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.default = FooterModalJira;
